export default "__VITE_ASSET__Bu52gox___"